<template>
  <div id="chart-table-box">
    <chart-title leftTitle="OMS转图延期预警">
      <el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-right: 20px"
        >详 情</el-button
      ></chart-title
    >
    <div id="chart-table">
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: 100%; margin-top: 10px"
      />
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "right_2",
  components: { ChartTitle },
  data() {
    return {
      config: {
        rowNum: 5,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        align: [
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
        ],
        columnWidth: [130, "", "", "", ""],
        data: [
          [
            `<span style="color:#409EFF">转图人员</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(-2)}">超期 -2天</span>`,
          ],
          [
            `<span style="color:#409EFF">转图人员</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(0)}">超期 0天</span>`,
          ],
          [
            `<span style="color:#409EFF">转图人员</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(-2)}">超期 -2天</span>`,
          ],
          [
            `<span style="color:#409EFF">转图人员</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(2)}">超期 2天</span>`,
          ],
          [
            `<span style="color:#409EFF">转图人员</span>`,
            `<span style="color:#409EFF">202212160001</span>`,
            `<span style="color:#409EFF">商家名</span>`,
            `<span style="color:#409EFF">客户名</span>`,
            `<span style="color:${this.getColor(0)}">超期 0天</span>`,
          ],
        ],
      },
    };
  },
  props: {},
  created() {},
  mounted() {},

  methods: {
    getColor(val) {
      if (val == 0) {
        return "#fee588";
      } else if (val < 0) {
        return "#F56C6C";
      } else {
        return "#409EFF";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-table-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 23vh;

  #chart-table {
    height: calc(100% - 30px);
    background: transparent;
  }
}
</style>

